import React, { useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../hooks/redux';

import {
    Autocomplete as AlchemyAutocomplete,
} from '@amzn/alchemy-components-react';

import { setSearchTerm } from '../../slices/favouriteFilterSlice';
import i18n from '../../i18n';
import { RootState } from '../../types';

export default () => {
    const dispatch = useAppDispatch()
    const myFavourites = useSelector((state: RootState) => state.myFavourites);
    const [autoCompeleteOptions, setAutoCompeleteOptions] = useState<Array<{label: string, value: string}>>([])

    useEffect(() => {
        setAutoCompeleteOptions(myFavourites.map((data) => ({label:data.title, value:data.entity})))
    }, [myFavourites])

    const handleInput = (e: React.SyntheticEvent) => {
        const input = (e.target as any)._typedValue
        if (input.length === 0) {
            dispatch(setSearchTerm(''))
        }
    }

    return(
        <div style={{"width": "300px"}}>
            <AlchemyAutocomplete
                placeholder={i18n.t('actions:search-by-title')}
                label=""
                clickOpen
                maxHeight="280px"
                options={autoCompeleteOptions}
                onChange={(e) => dispatch(setSearchTerm(e.target.value))}
                onInput={handleInput}
                trigger={2}
                noOptionsLabel={i18n.t('universal:no-options')}
            />
        </div>
    )
}
